(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.factory('organizationActions', organizationActionsFactory);

	/** @ngInject */
	function organizationActionsFactory(api, $q, dispatcher, ActionTypesEnum, $translate) {
		return {
			getOrganizationsListByType: getOrganizationsListByType,
			getOrganizationById: getOrganizationById,
			getSupportedOrganizationList: getSupportedOrganizationList,
			createChildOrganization: createChildOrganization,
			updateChildOrganization: updateChildOrganization,
			deleteOrganization: deleteOrganization,
			getAllCompaniesShort: getAllCompaniesShort,
			getAllRegionsShort: getAllRegionsShort,
			getAllSitesShort: getAllSitesShort,
			getForUserCreateOrganizationList: getForUserCreateOrganizationList,
			createUserForSelectedOrganizationAndRole: createUserForSelectedOrganizationAndRole,
			getForUserOrganizationListByUserId: getForUserOrganizationListByUserId,
			updateUserForSelectedOrganizationAndRole: updateUserForSelectedOrganizationAndRole,
			getAllSitesForExactUser: getAllSitesForExactUser,
			getOrganizationsCompanyById: getOrganizationsCompanyById,
			updateOrganizationVoucherExpirationDays: updateOrganizationVoucherExpirationDays
		};

		function getOrganizationsListByType() {
			var deferred = $q.defer();
			api.getOrganizationsListByType().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getOrganizationById(organizationId) {
			var deferred = $q.defer();
			api.getOrganizationById(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSupportedOrganizationList(organizationId) {
			var deferred = $q.defer();
			api.getSupportedOrganizationList(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createChildOrganization(data) {
			var deferred = $q.defer();
			api.createChildOrganization(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_SAVED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateChildOrganization(data) {
			var deferred = $q.defer();
			api.updateChildOrganization(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteOrganization(organizationId) {
			var deferred = $q.defer();
			api.deleteOrganization(organizationId).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_DELETED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllCompaniesShort(organizationId) {
			var deferred = $q.defer();
			api.getAllCompaniesShort(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllRegionsShort() {
			var deferred = $q.defer();
			api.getAllRegionsShort().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllSitesShort(organizationId) {
			var deferred = $q.defer();
			api.getAllSitesShort(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getForUserCreateOrganizationList() {
			var deferred = $q.defer();
			api.getForUserCreateOrganizationList().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createUserForSelectedOrganizationAndRole(data) {
			var deferred = $q.defer();
			api.createUserForSelectedOrganizationAndRole(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('USER_CREATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getForUserOrganizationListByUserId(userId) {
			var deferred = $q.defer();
			api.getForUserOrganizationListByUserId(userId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateUserForSelectedOrganizationAndRole(userId, data) {
			var deferred = $q.defer();
			api.updateUserForSelectedOrganizationAndRole(userId, data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('USER_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllSitesForExactUser() {
			var deferred = $q.defer();
			api.getAllSitesForExactUser().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getOrganizationsCompanyById(companyId) {
			var deferred = $q.defer();
			api.getOrganizationsCompanyById(companyId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateOrganizationVoucherExpirationDays(companyId, voucherExpirationDays) {
			var deferred = $q.defer();
			api.updateOrganizationVoucherExpirationDays(companyId, voucherExpirationDays).then(
				function (data) {
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('VOUCHER_EXPIRATION_DAYS_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

	}
})();
